import(/* webpackMode: "eager" */ "/codebuild/output/src3604966175/src/github.com/Singularity-DAO/sfi-frontend/apps/dapp/app/page.tsx");
